import { render, staticRenderFns } from "./FileSearchIcon.vue?vue&type=template&id=374374fc"
import script from "./FileSearchIcon.vue?vue&type=script&lang=js"
export * from "./FileSearchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports